import React from "react";
import { useEffect } from "react";
import { API_BASEURLICON } from "../../Config";

const Body = () => {
  useEffect(() => {
    const handleScroll = () => {
      const image = document.querySelector(".cus-image-vector-2 img");
      const position = image.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;

      if (position < screenHeight - 100) {
        image.classList.add("show");
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll(); // refresh par bhi check karega
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const imageUrl = API_BASEURLICON;

  useEffect(() => {
    const handleScroll = () => {
      const image = document.querySelector(".cus-image-vector-8 img");
      const position = image.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;
      if (position < screenHeight - 100) {
        image.classList.add("show");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // refresh par bhi check karega
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const image = document.querySelector(".cus-image-vector-4 img");
      const position = image.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;

      if (position < screenHeight - 100) {
        image.classList.add("show");
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll(); // refresh par bhi check karega

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const image = document.querySelector(".cus-image-vector-5 img");
      const position = image.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;

      if (position < screenHeight - 100) {
        image.classList.add("show");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // refresh par bhi check karega

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const image = document.querySelector(".cus-image-vector-3 img");
      const position = image.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;

      if (position < screenHeight - 100) {
        image.classList.add("show");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // refresh par bhi check karega

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const image = document.querySelector(".cus-image-vector-7 img");
      const position = image.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;

      if (position < screenHeight - 100) {
        image.classList.add("show");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // refresh par bhi check karega

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const image = document.querySelector(".overview-image-section img");
      const position = image.getBoundingClientRect().top;
      const screenHeight = window.innerHeight;
      if (position < screenHeight - 100) {
        image.classList.add("show");
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // refresh par bhi check karega

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <section
        className="services-overview with-top-padding cus-business-bg"
        id="services-overview"
      >
        <div
          className="content-wrapper services-container layoutId-2 single"
          id="b2c-section-2"
        >
          <div className="service with-margin ">
            <div className="content">
              <div className="service-logo">
                <img
                  src={`${imageUrl}Image/Website/1/B2C-whitelogo.png`}
                  alt="Pocketvila"
                  loading="lazy"
                />
              </div>
              <div>
                <h3 className="typewriter-5">
                  A one-stop solution for your <br /> business
                </h3>
              </div>
              <p className="sub-text">
                Receive online and in-store payments, manage your business and
                customers, avail financial products, and a lot more!
              </p>
              <ul className="service-features">
                <li>Accept payments via all-in-one QR</li>
                <li>Grow your business with a loan</li>
                <li>Manage customer records using Khata</li>
                <li>
                  Track and analyse payments: transactions, settlements &amp;
                  refunds
                </li>
              </ul>
              <div className="btn-section">
                {/* <div className="download-btn">
                  <span>Download App</span>
                  <img
                    src="https://fcpress.freecharge.in/api/mediamanager/media/GKs9zkAKN.svg"
                    alt="play-store"
                    loading="lazy"
                  />
                  <img
                    src="https://fcpress.freecharge.in/api/mediamanager/media/2nCOvzaaS.svg"
                    alt="app-store"
                    loading="lazy"
                  />
                </div> */}
                <a href="#">
                  <button
                    className="sc-a1e3fb67-1 imsHBJ know-more-btn"
                    width="100%"
                    type=""
                    data-test-id="secondaryBtn-know-more-btn"
                  >
                    Know More
                  </button>
                </a>
              </div>
            </div>
            <div className="section-img cus-image-vector-2 animation-css-789">
              <img
                src="assets/pwa-static/pwa/images/eSk4yfkVq.webp"
                alt="section-image"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="layout-3 layout-id-1 left-aligned cus-neend-money">
        <div className="content-wrapper">
          <div className="content-section">
            <div className="typewriter-6">
              <h3>
                One app for all your <br />
                money needs
              </h3>
            </div>
            <div className="text-content">
              <p>
                Recharges & Bill Payments, UPI, Personal Loan, Credit Cards,
                <br /> Free Credit Check, and a lot more
              </p>
            </div>
            <div className="download-icons qrcode">
              <div className="qr-code-wrapper">
                <img
                  src="assets/pwa-static/pwa/images/new_pocket_qr.webp"
                  style={{ height: "149px" }}
                />
              </div>
              <div>
                <p className="qr-code-text">Scan QR code to download app</p>
                <a href="https://play.google.com/store/apps/details?id=com.solution.pocketvila&hl=en_IN">
                  <img
                    src="https://fcpress.freecharge.in/api/mediamanager/media/qKsU_pK09.svg"
                    alt="Play Store"
                    loading="lazy"
                  />
                </a>
                <a href="#">
                  <img
                    src="https://fcpress.freecharge.in/api/mediamanager/media/2X7XqJs-f.svg"
                    alt="App Store"
                    loading="lazy"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="overview-image-section animation-css-789">
            <img
              src="assets/pwa-static/pwa/images/seoPages/homepage/mobile.webp"
              alt="mobile"
              loading="lazy"
            />
          </div>
        </div>
      </section>
      <section
        className="services-overview  with-bottom-padding"
        style={{ background: "#FFF" }}
        id="services-overview"
      >
        <div className="services-container layoutId-1 multiple">
          <div className="service with-margin cus-medi-manager">
            <div className="content content-wrapper" style={{ float: "right" }}>
              <div className="service-logo">
                <img
                  src="https://fcpress.freecharge.in/api/mediamanager/media/xTa7ocAm1.svg"
                  alt="Personal Loan"
                  loading="lazy"
                />
                <p>Personal Loan</p>
              </div>
              <div>
                <h3>
                  Get a Personal Loan in <br /> 2 Minutes
                </h3>
              </div>
              <p className="sub-text">
                Instant personal loan of up to Rs.5 Lakhs! It&#x27;s 100%
                digital and paperless
              </p>
              <ul className="service-features">
                <li>Instant disbursement</li>
                <li>Interest rate starting at 14% per annum</li>
                <li>Flexible repayment tenure</li>
              </ul>
              <div className="btn-section">
                <div className="download-icons ">
                  <div>
                    <a href="https://play.google.com/store/apps/details?id=com.solution.pocketvila&hl=en_IN">
                      <img
                        src="https://fcpress.freecharge.in/api/mediamanager/media/qKsU_pK09.svg"
                        alt="Play Store"
                        loading="lazy"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="section-img cus-image-vector-3"
              style={{ float: "right" }}
            >
              <img
                src="assets/pwa-static/pwa/images/1ELtgwjVL.webp"
                alt="section-image"
                loading="lazy"
              />
            </div>
          </div>
          <div className="service with-margin cus-medi-manager-2">
            <div className="content">
              <div className="service-logo">
                <img
                  src="https://fcpress.freecharge.in/api/mediamanager/media/8imUU5JHm.svg"
                  alt="Credit card"
                  loading="lazy"
                />
                <p>Credit card</p>
              </div>
              <div>
                <h3>
                  Make shopping more <br /> rewarding with Axis Bank <br />{" "}
                  pocketvila Plus Credit Card
                </h3>
              </div>
              <p className="sub-text">
                Enjoy up to 5% unlimited cashback on all your spends. T&amp;C
                Apply
              </p>
              <ul className="service-features">
                <li>Zero joining fee</li>
                <li>100% digital process</li>
                <li>Annual fee waiver on ₹50,000+ spends</li>
              </ul>
              <div className="btn-section">
                <div className="download-icons ">
                  <div>
                    <a href="https://play.google.com/store/apps/details?id=com.solution.pocketvila&hl=en_IN">
                      <img
                        src="https://fcpress.freecharge.in/api/mediamanager/media/qKsU_pK09.svg"
                        alt="Play Store"
                        loading="lazy"
                      />
                    </a>
                  </div>
                </div>
                <a href="axis-bank-pocketvila-plus-credit-card.html">
                  <button
                    className="sc-a1e3fb67-1 imsHBJ know-more-btn"
                    width="100%"
                    type=""
                    data-test-id="secondaryBtn-know-more-btn"
                  >
                    Know More
                  </button>
                </a>
              </div>
            </div>
            <div className="section-img cus-image-vector-4">
              <img
                src="assets/pwa-static/pwa/images/1GNTqoEKb.webp"
                alt="section-image"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
      <section
        className="services-overview  top-padding"
        style={{ background: " #eeeeff" }}
        id="services-overview"
      >
        <div className="services-container layoutId-1 single content-wrapper cus-lazy-villa">
          <div className="service">
            <div className="content">
              <div className="service-logo">
                <img
                  src={`${imageUrl}Image/Website/1/B2C-logo.png`}
                  alt="Pocketvila Business Loan"
                  loading="lazy"
                />
                <p>Pocketvila Business Loan</p>
              </div>
              <div className="typewriter-7">
                <h3>
                  Grow your business with <br />
                  our loans
                </h3>
              </div>
              <p className="sub-text">
                Get a business loan of up to 10 Lakh in just a few taps on the
                Pocketvila App
              </p>
              <ul className="service-features">
                <li>Lowest interest rate</li>
                <li>No security or collateral required</li>
                <li>100% digital process &amp; quick disbursal</li>
                <li>Get an Axis Bank current account</li>
              </ul>
              <div className="btn-section">
                {/* <div className="download-btn">
                  <span>Download App</span>
                  <img
                    src="https://fcpress.freecharge.in/api/mediamanager/media/GKs9zkAKN.svg"
                    alt="play-store"
                    loading="lazy"
                  />
                  <img
                    src="https://fcpress.freecharge.in/api/mediamanager/media/2nCOvzaaS.svg"
                    alt="app-store"
                    loading="lazy"
                  />
                </div> */}
                <a href="#">
                  <button
                    className="sc-a1e3fb67-1 imsHBJ know-more-btn"
                    width="100%"
                    type=""
                    data-test-id="secondaryBtn-know-more-btn"
                  >
                    Know More
                  </button>
                </a>
              </div>
            </div>
            <div className="section-img cus-image-vector-5 animation-css-789">
              <img
                src="assets/pwa-static/pwa/images/e_WT2724L.webp"
                alt="section-image"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
      <div
        className="security-container"
        style={{
          background:
            "url(https://fcpress.freecharge.in/api/mediamanager/media/hbUN7XeOk.svg) center center / cover no-repeat",
        }}
      >
        <div className="content-wrapper">
          <div className="security-badge cus-image-vector-8 animation-css-789">
            <img
              src="https://fcpress.freecharge.in/api/mediamanager/media/7p4FWb2pf.svg"
              alt="security-badge"
            />
          </div>
          <div className="security-info">
            <p className="header">Trusted, Safe &amp; Secure</p>
            <p className="sub-header">
              Bank Grade Security, Fully Encrypted, 24X7 Customer Support, App
              Lock
            </p>
            <div className="certified-container">
              <div className="logos">
                <img
                  src="https://fcpress.freecharge.in/api/mediamanager/media/DgHJOvJYp.svg"
                  alt="trusted-partner-0"
                />
              </div>
              <div className="logos">
                <img
                  src="https://fcpress.freecharge.in/api/mediamanager/media/6ZrQKBBoU.svg"
                  alt="trusted-partner-1"
                />
              </div>
              <div className="logos">
                <img
                  src="https://fcpress.freecharge.in/api/mediamanager/media/4W1-4LipK.svg"
                  alt="trusted-partner-2"
                />
              </div>
              <div className="logos">
                <img
                  src="https://fcpress.freecharge.in/api/mediamanager/media/ZO8fhY3dX.svg"
                  alt="trusted-partner-3"
                />
              </div>
              <div className="logos">
                <img
                  src="https://fcpress.freecharge.in/api/mediamanager/media/geX-KN5zR.svg"
                  alt="trusted-partner-4"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <section
        className="services-overview  service-content-003"
        id="services-overview"
      >
        <div
          className="services-container layoutId-1 single content-wrapper"
          id="service-content-01"
        >
          <div className="service grid-features ">
            <div className="content">
              <div className="service-logo">
                <img
                  src="https://fcpress.freecharge.in/api/mediamanager/media/x4brM5ZJ3.svg"
                  alt="Credit Score"
                  loading="lazy"
                />
                <p>Credit Score</p>
              </div>
              <div>
                <h3>
                  Track your Credit score <br />
                  for Free
                </h3>
              </div>
              <p className="sub-text">
                Check your score and get your full credit report in seconds.
                100% secure!
              </p>
              <ul className="service-features">
                <li>Get detailed insights</li>
                <li>Check overdues</li>
                <li>View active loans</li>
                <li>Access Better Deals</li>
              </ul>
              <div className="btn-section">
                {/* <div className="download-btn">
                  <span>Download App</span>
                  <img
                    src="https://fcpress.freecharge.in/api/mediamanager/media/GKs9zkAKN.svg"
                    alt="play-store"
                    loading="lazy"
                  />
                  <img
                    src="https://fcpress.freecharge.in/api/mediamanager/media/2nCOvzaaS.svg"
                    alt="app-store"
                    loading="lazy"
                  />
                </div> */}
                <a href="credit-score-check.html">
                  <button
                    className="sc-a1e3fb67-1 imsHBJ know-more-btn"
                    width="100%"
                    type=""
                    data-test-id="secondaryBtn-know-more-btn"
                  >
                    Know More
                  </button>
                </a>
              </div>
            </div>
            <div className="cus-vector-2 cus-image-vector-7 animation-css-789">
              <img src="assets/pwa-static/pwa/images/credit-Mob.svg" />
            </div>
            {/* <div className="lottie-section"></div> */}
          </div>
        </div>
      </section>
      <div className="pop-up-wrapper services-popup  swipe-bottom">
        <div
          className="pop-up  "
          style={{
            maxWidth: "890px",
            maxHeight: "562px",
            minWidth: "890px",
            minHeight: "562px",
          }}
        >
          <div
            className="download-app-container"
            style={{ background: "#FFF" }}
          >
            <div className="content-wrapper">
              <div className="qr-section">
                <div className="qr-code">
                  <canvas
                    width="177"
                    height="177"
                    style={{ height: "177px" }}
                  ></canvas>
                </div>
                <img
                  src="https://assets/pwa-static/pwa/images/home/pointer-grey.svg"
                  alt="pointer"
                />
              </div>
              <p className="heading-1">Scan the QR code to download the app</p>
              <p className="heading-2">Download the Pocketvila App</p>
              <div className="download-app">
                <a href="#" target="_blank" rel="noreferrer">
                  <img
                    src="https://fcpress.freecharge.in/api/mediamanager/media/qKsU_pK09.svg"
                    alt="Play Store"
                    className="google-play"
                  />
                </a>
                <a href="#" target="_blank" rel="noreferrer">
                  <img
                    src="https://fcpress.freecharge.in/api/mediamanager/media/2X7XqJs-f.svg"
                    alt="App Store"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Body;
